import {computed, Injectable, signal} from '@angular/core';
import {LoaderQueueItem} from '../types/LoaderQueueItem';

@Injectable()
export class LoaderService {
  private loaderQueue = signal<LoaderQueueItem[]>([]);
  public loadingItem = computed<LoaderQueueItem>(() => (this.loaderQueue().length > 0 ? this.loaderQueue()[0] : null));

  public addToQueue(item: LoaderQueueItem): void {
    this.loaderQueue.update((queue) => [...queue, item]);
  }

  public removeFromQueue(id: number): void {
    this.loaderQueue.update((queue) => queue.filter((item) => item.id !== id));
  }

  public getQueue(): LoaderQueueItem[] {
    return this.loaderQueue();
  }

  public generateQueueId(): number {
    const min = 1000;
    const max = 99999;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public clearQueue(): void {
    this.loaderQueue.set([]);
  }
}
